'use client'
import { useState } from 'react'
import { Modal, Typography } from 'antd'

import { Button, BookingOptions } from '@/src/components'
import { Physician } from '@/src/interfaces'

const { Text, Title } = Typography

export const PhoneButtonWithModal = ({
  physician,
  physicianName,
  locationType,
}: {
  physician: Physician
  physicianName: string
  locationType: 'Primary' | 'Additional'
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const handlePhoneClick = () => {
    setIsModalVisible(true)
  }

  return (
    <>
      <div className='print:hidden'>
        <div className='w-fit'>
          <Button
            type='primary'
            icon={'phone'}
            onClick={handlePhoneClick}
            text='View Phone Number'
          />
        </div>
        <Modal
          open={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          footer={null}
        >
          <Title
            level={5}
            className='pr-2'
          >{`${physicianName}'s ${locationType} Practice Location Phone Number`}</Title>
          <BookingOptions physician={physician} showPhoneBooking={true} />
        </Modal>
      </div>
      <div className='hidden print:flex print:flex-col'>
        <Text strong>Phone Number:</Text>
        <Text>{physician.phone}</Text>
      </div>
    </>
  )
}
